export default __webpack_public_path__ + "media/images/nav-logo-eb8d39b6dad7bbc8e0f3fec2b7baa4c4.png";